import { forwardRef } from 'react';

import styled from 'styled-components';

import ErrorMessage, { ErrorMessageWrapper } from '@components/ErrorMessage';
import { ComponentEnhancer, TypeOfPropsFor } from '@utils/types';

export type ErrorDisplayLayout = {
  layout?: 'row' | 'column';
  isNotMessage?: boolean;
};
export const Container = styled.div<ErrorDisplayLayout>`
  display: flex;
  flex-direction: ${(p) => p.layout};
  row-gap: ${(p) => (p.isNotMessage ? '0' : '10px')};
  column-gap: 15px;
  position: relative;
  &[data-error='true'] {
    ${ErrorMessageWrapper} {
      position: ${(p) => p.layout === 'column' && 'relative'};
    }
  }
`;
type ErrorProps = ErrorDisplayLayout & {
  hasError?: boolean;
  errorMessage?: string;
  errorPropName?: string;
  showErrorIcon?: boolean;
  isNotMessage?: boolean;
};
export const FormField: ComponentEnhancer<ErrorProps> = ({
  Component,
  hasError,
  errorMessage,
  errorPropName = 'hasError',
  layout = 'column',
  showErrorIcon = false,
  children,
  isNotMessage,
  ...rest
}) => {
  const errorProps = errorPropName ? { [errorPropName]: hasError } : {};
  const props = { ...rest, ...errorProps } as unknown as TypeOfPropsFor<
    typeof Component
  > &
    Partial<Record<string, unknown>>;
  return (
    <Container
      isNotMessage={isNotMessage}
      layout={layout}
      key='parent'
      data-error={hasError}
    >
      <Component {...props} />
      {hasError ? (
        <ErrorMessage message={errorMessage} showIcon={showErrorIcon} />
      ) : null}
      {children}
    </Container>
  );
};

export default forwardRef(FormField) as ComponentEnhancer<ErrorProps>;
